import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/jamsai/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const jamsaiApi = {
  getJamsaiCustomerGroup: (page_id) => {
    return instance().get(`/${page_id}/customer-group`)
  },
  getBroadcastLog: (data) => {
    const { page_id, boradcast_id, params } = data
    return instance().get(`/${page_id}/broadcast-log/${boradcast_id}`, { params })
  }
}

export default jamsaiApi



// WEBPACK FOOTER //
// ./src/api/jamsai.js